module.exports = __webpack_public_path__ + "img/sup_deposit_crypto4.ed2a7bda.jpg";